<template>
  <el-dialog
    :close-on-click-modal="false"
    title="制单"
    :visible.sync="visible"
    width="800px"
    class="remarkDialog"
    :before-close="handleClose"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="108px">
      <el-form-item label="揽货方式：" prop="shipWay">
        <el-radio-group v-model="form.shipWay">
          <el-radio label="01">快递取件</el-radio>
          <el-radio label="02">自行寄件</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="form.shipWay == '01'"
        prop="pickupTimeId"
        label="取件日期："
      >
        <el-select
          clearable
          v-model="form.pickupTimeId"
          placeholder="请选择取件日期"
          class="input"
          style="width: 100%"
          size="small"
        >
          <el-option
            v-for="(value, index) in pickupTimeList"
            :key="index"
            :label="value.date_text"
            :value="value.pickup_time_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.shipWay == '01'" label="上门取件地址：">
        <el-input
          readonly
          v-model="address"
          type="textarea"
          :rows="4"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small"> 确定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex"
import { sendByHand, shippingParameter, shippingOrder } from "@/api/order/all"

export default {
  name: "RemarkDialog",
  data() {
    return {
      form: {
        shipWay: "01",
        addressId: "",
        appId: "",
        pickupTimeId: "",
        trackingNumber: "",
        packageNumber: "",
      },
      rules: {
        shipWay: [
          { required: true, message: "请选择揽货方式", trigger: "blur" },
        ],
        addressId: [{ required: true, message: "请选择地址", trigger: "blur" }],
      },
      addressList: [],
      pickupTimeList: [],
      address: "",
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    orderData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    async visible() {
      if (this.visible) {
        this.form = {
          shipWay: "01",
          addressId: "",
          appId: "",
          pickupTimeId: "",
          trackingNumber: "",
          packageNumber: "",
          pickupTime: "",
          pickupAddr: "",
        }
        this.address = ''
        this.addressList = []
        let appId = this.orderData.appId
        let result = await shippingParameter({ appId: appId })
        if (result.data.response.pickup.address_list.length > 0) {
          let address = result.data.response.pickup.address_list[0]
          this.form.pickupAddr = address.address

          this.address = `${address.address}\n${address.town},${address.district},${address.city},${address.state}\n${address.region},${address.zipcode}`
          this.pickupTimeList = address.time_slot_list
          this.form.addressId = address.address_id
          this.form.appId = appId
          //取最近的时间
          if (address.time_slot_list.length > 0) {
            let currentIndex = 0
            let pickupTime = new Date(
              address.time_slot_list[0].date_text
            ).getTime()
            for (
              let index = 0;
              index < address.time_slot_list.length;
              index++
            ) {
              let nowTime = new Date(
                address.time_slot_list[index].date_text
              ).getTime()
              if (nowTime > pickupTime) {
                currentIndex = index
                pickupTime = nowTime
              }
            }
            this.form.pickupTimeId =
              address.time_slot_list[currentIndex].pickup_time_id
            this.form.pickupTime =
              address.time_slot_list[currentIndex].date_text
          }
        }
      }
    },
  },
  methods: {
    sure() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          shippingOrder(this.form).then((response) => {
            if (response.code == "200") {
              this.msgSuccess("发货成功！")
            } else {
              this.msgError("提交失败！")
            }
            this.$emit("onClose", this.form)
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleClose() {
      this.$emit("onClose")
    },
    handleChangeAddress() {
      for (let record of this.addressList) {
        if (record.addressId == this.form.addressId) {
          this.pickupTimeList = record.pickupTimeList
        }
      }
    },
  },
}
</script>

<style scoped>
.remarkDialog {
  font-size: 12px;
}

.item {
  display: flex;
  flex-wrap: wrap;
}

.color {
  padding: 1px;
  margin: 3px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 4px;
  border: 1px solid #eee;
}

.color.active {
  border: 1px solid #333;
}

.color-inner {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}
</style>
